"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Badge: function() {
        return _Badge.Badge;
    },
    CounterBadge: function() {
        return _CounterBadge.CounterBadge;
    },
    PresenceBadge: function() {
        return _PresenceBadge.PresenceBadge;
    },
    badgeClassNames: function() {
        return _Badge.badgeClassNames;
    },
    counterBadgeClassNames: function() {
        return _CounterBadge.counterBadgeClassNames;
    },
    presenceAvailableFilled: function() {
        return _PresenceBadge.presenceAvailableFilled;
    },
    presenceAvailableRegular: function() {
        return _PresenceBadge.presenceAvailableRegular;
    },
    presenceAwayFilled: function() {
        return _PresenceBadge.presenceAwayFilled;
    },
    presenceAwayRegular: function() {
        return _PresenceBadge.presenceAwayRegular;
    },
    presenceBadgeClassNames: function() {
        return _PresenceBadge.presenceBadgeClassNames;
    },
    presenceBlockedRegular: function() {
        return _PresenceBadge.presenceBlockedRegular;
    },
    presenceBusyFilled: function() {
        return _PresenceBadge.presenceBusyFilled;
    },
    presenceDndFilled: function() {
        return _PresenceBadge.presenceDndFilled;
    },
    presenceDndRegular: function() {
        return _PresenceBadge.presenceDndRegular;
    },
    presenceOfflineRegular: function() {
        return _PresenceBadge.presenceOfflineRegular;
    },
    presenceOofRegular: function() {
        return _PresenceBadge.presenceOofRegular;
    },
    presenceUnknownRegular: function() {
        return _PresenceBadge.presenceUnknownRegular;
    },
    renderBadge_unstable: function() {
        return _Badge.renderBadge_unstable;
    },
    useBadgeStyles_unstable: function() {
        return _Badge.useBadgeStyles_unstable;
    },
    useBadge_unstable: function() {
        return _Badge.useBadge_unstable;
    },
    useCounterBadgeStyles_unstable: function() {
        return _CounterBadge.useCounterBadgeStyles_unstable;
    },
    useCounterBadge_unstable: function() {
        return _CounterBadge.useCounterBadge_unstable;
    },
    usePresenceBadgeStyles_unstable: function() {
        return _PresenceBadge.usePresenceBadgeStyles_unstable;
    },
    usePresenceBadge_unstable: function() {
        return _PresenceBadge.usePresenceBadge_unstable;
    }
});
const _Badge = require("./Badge");
const _PresenceBadge = require("./PresenceBadge");
const _CounterBadge = require("./CounterBadge");
